import { Field } from "formik";
import RadioOptions from "../../services/models/radioOptions.model";

function CustomRadio({
  id,
  label,
  value,
  name,
  className,
  radioClassName,
  manualFieldsChangeOnOptionClick
}: RadioOptions): JSX.Element {
  return (
    <label
      htmlFor={id + name}
      key={id}
      className={`bg-white inline-block mr-4 p-3 rounded-[16px] text-center my-3 border-2 ${className}`}
    >
      <span className="mr-12">{label}</span>
      <Field
        type="radio"
        id={id + name}
        name={name}
        value={value}
        className={radioClassName}
        onClick={manualFieldsChangeOnOptionClick}
      />
    </label>
  );
}

export default CustomRadio;
